import axios from 'axios';
import { getAllPreviewInventoryData } from './preview-encodes-service';

const PREVIEW_INVENTORY = 'previewInventory';

export const getInBreakAsset = async ({ accountId, advertiserId, assetType, assetId }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/advertiser/${advertiserId}/asset/${assetType}/${assetId}`;
  return axios.get(url).then((response) => response.data);
};

export const getInStreamAsset = async ({ accountId, assetType, assetId }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/asset/${assetType}/${assetId}`;
  return axios.get(url).then((response) => response.data);
};

export const postTransitionCardIdsByAccountAdvertiser = async (accountId, advertiserId, assetType, cardIds) => {
  const idQuery = { ids: cardIds || [] };
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/advertiser/${advertiserId}/asset/${assetType}/by_ids`;
  return axios.post(url, idQuery).then((response) => response.data);
};

export const getAssetsByAccountAdvertiserAndType = async ({ accountId, advertiserId, assetType, search = '' }) => {
  if (assetType === PREVIEW_INVENTORY) {
    return getAllPreviewInventoryData(accountId);
  }

  const url = `${SERVICE_URL}/api/v1/account/${accountId}/advertiser/${advertiserId}/assets/${assetType}${search}`;
  return axios.get(url).then((response) => response.data);
};

export const getAssetsByAccountAndType = async ({ accountId, assetType, search = '' }) => {
  if (assetType === PREVIEW_INVENTORY) {
    return getAllPreviewInventoryData(accountId);
  }

  const url = `${SERVICE_URL}/api/v1/account/${accountId}/assets/${assetType}${search}`;
  return axios.get(url).then((response) => response.data);
};

export const updateInBreakAsset = async ({ accountId, advertiserId, assetType, asset }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/advertiser/${advertiserId}/asset/${assetType}`;
  return axios.put(url, asset).then((response) => response.data);
};

export const updateInStreamAsset = async ({ accountId, assetType, asset }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/asset/${assetType}`;
  return axios.put(url, asset).then((response) => response.data);
};

export const getCreativesByAsset = async (accountId, advertiserId, assetType, assetId) => {
  const url =
    `${SERVICE_URL}/api/v1/account/${accountId}` +
    `/advertiser/${advertiserId}/asset/${assetType}/${assetId}/creatives`;
  return axios.get(url).then((response) => response.data);
};

export const deleteAsset = async (accountId, advertiserId, assetType, assetId, contentType) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/advertiser/${advertiserId}/asset/${assetType}/${assetId}`;
  return axios.delete(url, { data: { contentType } }).then((response) => response.data);
};
